// data/webProjects.js

import samrat from "../../image/stis.png";
import smartcard from "../../image/smartcard.jpeg";
import nestiva from "../../image/nestiva.jpeg";

const websiteProjects = [
    {
      id: 1,
      category: "Website",
      title: "Samrat Tech IT Solutions",
      description:
        "Premium corporate website with responsive UI, SEO optimization and service showcase.",
      image: samrat,
      url: "https://samrattechitsolutions.com",
    },
  
    {
      id: 2,
      category: "Marketing",
      title: "Smartcard",
      description:
        "Responsive eCommerce website with shopping, cart, wishlist, and secure checkout.",
      image: smartcard,
      url: "https://smartcard-site.netlify.app/",
    },
  
    {
      id: 3,
      category: "Healthcare",
      title: "Nestiva Hospital",
      description:
        "Modern hospital website with appointment booking and AI assistant.",
      image: nestiva,
      url: "https://stellar-pudding-bfbd5b.netlify.app/",
    },
  ];
  
  export default websiteProjects;